/*
 * Presentation adapter for the review form's fixed United States (+1) field.
 * It joins that visible prefix to national digits and accepts the same number
 * pasted with its prefix. This is not an identity/authorization normalizer:
 * the backend still validates and canonicalizes every request and verification.
 * An explicit different country code is never reinterpreted as United States.
 */
export const US_REVIEW_MOBILE_ERROR = "Enter a 10-digit U.S. mobile number. The +1 country code is already included.";

export const usReviewMobileContact = (value) => {
  const entered = typeof value === "string" ? value.trim() : "";
  if (!entered || !/^\+?[\d\s().-]+$/.test(entered)) return "";
  const digits = entered.replace(/\D/g, "");
  if (entered.startsWith("+")) return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : "";
  if (digits.length === 10) return `+1${digits}`;
  return digits.length === 11 && digits.startsWith("1") ? `+${digits}` : "";
};

// For initial/pasted/blurred values only; ordinary edits keep their own caret
// and text. The country prefix is rendered separately, never in this value.
export const usReviewMobileFieldValue = (value) => {
  const contact = usReviewMobileContact(value);
  return contact ? contact.slice(2) : value;
};
